import Box from "./Box";
export const Title = Box.withComponent("h1");
Title.defaultProps = {
  fontSize: [4, 5],
  lineHeight: [4, 5],
  fontWeight: "thin",
  mt: 2,
  mb: 2
};

export const Heading = Box.withComponent("h2");
Heading.defaultProps = {
  fontSize: [3, 4],
  lineHeight: [3, 4],
  fontWeight: "light",
  color: "semiMuted",
  mt: 2,
  mb: 2
};

export const SubHeading = Box.withComponent("h3");
SubHeading.defaultProps = {
  fontSize: 2,
  lineHeight: 2,
  fontWeight: "bold",
  mt: 0,
  mb: 0,
  pt: 2,
  pb: 3
};
